import { IFeature } from 'mod/featureV2/interface';

export const swiperToggleBanner: IFeature= {
    type: 'swiperToggleBanner',
    moduleId: 'swiperToggleBanner',
    title: 'swiperToggleBanner',
    description: 'description',
    config: {
        width: 368,
        height: 276,
        spaceBetweenColumns: 24,
    },
    list: new Array(10).fill(void 0).map(() => ({
        src: 'asset/width-1156/picture/154337dc4a18eeca5310d159ae20c253.jpg',
        toggle: 'asset/width-736/picture/4ee2c3760527aacfc973cbc6033b4cb2.png',
        href: '/?mock=1',
    }))
}